import { ActionTypes } from './constants'

const initialState = {
    path: "",
    toggleLoadingScreen: false,
    isFormSubmit: false
};

const MasterReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.SET_PATH:
            return { ...state, path: payload }
        case ActionTypes.DO_TOGGLE_LOADING_SCREEN:
            return { ...state, toggleLoadingScreen: !state.toggleLoadingScreen }
        case ActionTypes.DO_FORM_SUBMIT_LOADING:
            return { ...state, isFormSubmit: !state.isFormSubmit }
        default:
            return state;
    }
};

export default MasterReducer;